<template>
  <div
    class="container"
    style="
      overflow-y: auto;
      position: relative !important;
      margin-bottom: 3.24074rem;
    "
  >
    <!-- 标题 -->
    <div class="top_title">
      <span>校长听评课</span>
      <span class="icon_add" @click="add_ReturnVisit"></span>
    </div>
    <!-- tab栏 -->
    <div
      class="weui-flex top_tabs"
      style="position: fixed; top: 0rem; width: 100%"
    >
      <div class="weui-flex__item">
        <span :class="{ active: tabFlag == false }" @click="clickTab(1)"
          >最近一个月</span
        >
      </div>
      <div class="weui-flex__item">
        <span :class="{ active: tabFlag == true }" @click="clickTab(2)"
          >全部</span
        >
      </div>
    </div>
    <!-- 内容 -->
    <div class="read_items" style="overflow-y: auto">
      <div style="border: 0 !important; margin-top: 5.4rem">
        <div
          @click="returnVisit_Info(item.I_KEY)"
          v-for="(item, index) in info.dataList"
        >
          <el-card style="margin: 0.462962rem; font-size: 0.76rem">
            <div v-html="toFormatText(item.I_INFO)"></div>
          </el-card>
        </div>
        <template v-if="info.dataList.length == 0 && message != ''">
          <NoRecord :Message="message"></NoRecord>
        </template>
      </div>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
import DataRequestFactory from "@/factories/dataRequestFactory.js";
import weui from "weui.js";
import Footer from "../components/Footer.vue";
import NoRecord from "../components/NoRecord.vue";
export default {
  name: "",
  data() {
    return {
      I_DATE_FIELD: "",
      nav: {
        sy: true,
        jchd: false,
        yyst: false,
        wd: false,
      },
      info: {
        dataList: [],
      },
      tabFlag: false,
      message: "",
    };
  },
  components: {
    Footer,
    NoRecord,
  },
  created() {
    if (this.$router.options.routes[2].name !== 'H600030') {
      location.reload();
    }
    this.init();
  },
  methods: {
    //切换tab
    clickTab(value) {
      if (value == 1) {
        this.tabFlag = false;
        let requestParams = {
          I_DATE_FIELD: "M1",
        };
        DataRequestFactory.I600030().then((response) => {
          this.info = response;
          if (this.info.dataList.length == 0) {
            this.message = "无查询记录！";
          } else {
            this.message = "";
          }
        });
      } else {
        this.tabFlag = true;
        let requestParams = {
          I_DATE_FIELD: "ALL",
        };
        DataRequestFactory.I600030().then((response) => {
          this.info = response;
          if (this.info.dataList.length == 0) {
            this.message = "无查询记录！";
          } else {
            this.message = "";
          }
        });
      }
    },
    //初始化
    init() {
      let requestParams = {
        I_DATE_FIELD: "M1",
      };
      DataRequestFactory.I600030().then((response) => {
        this.info = response;
        console.log(this.info.dataList);
        if (this.info.dataList.length == 0) {
          this.message = "无查询记录！";
        } else {
          this.message = "";
        }
      });
    },
    //格式化
    toFormatText(val) {
      return val.replace("\n", "<br/>");
    },
    //添加听评课
    add_ReturnVisit() {
      this.$router.push("/H600040");
    },
    //听评课详情
    returnVisit_Info(val) {
      window.localStorage.setItem("H600030", val);
      this.$router.push({
        path: "/" + "H300000" + "/" + val,
      });
    },
  },
  mounted() {
    var win_h = $(window).height(); //关键代码
    $("body").height(win_h); //关键代码
    this.init();
  },
};
</script>

<style scoped>
@import "../assets/css/common.css";
</style>
<style scoped>
.icon_add {
  width: 1rem;
  height: 1rem;
  background: url("../../src/assets/images/add.png") no-repeat center;
  background-size: 1rem 1rem;
  display: inline-block;
  position: absolute;
  right: 1.5rem;
  top: 0.7rem;
}

.top_tabs {
  height: 2.4rem;
  background-color: #fff;
  margin-top: 2.4rem;
}

.top_tabs .weui-flex__item {
  text-align: center;
}

.top_tabs .weui-flex__item span {
  display: inline-block;
  padding: 0 0.4rem;
  height: 2.4rem;
  line-height: 2.4rem;
}

.top_tabs .weui-flex__item span.active {
  color: #54c3f1;
  border-bottom: 1px solid #54c3f1;
}
</style>



// WEBPACK FOOTER //
// src/pages/H600030.vue